import { scaleTime } from 'd3-scale';

export type TimeRange = {
  min: number;
  max: number;
};

export type DataRange = {
  min: Date;
  max: Date;
};

export type TimeArray = [number, number];

export const dateRangeToTimeRange = (dateRange: DataRange) => {
  return {
    min: dateRange.min.getTime(),
    max: dateRange.max.getTime(),
  };
};

export const dateRangeToTimeRangeArray = (dateRange: DataRange): TimeArray => {
  const { min, max } = dateRangeToTimeRange(dateRange);
  return [min, max];
};

export const generateTicks = (ticksCount: number, dateRange: DataRange) => {
  return scaleTime(dateRangeToTimeRangeArray(dateRange))
    .domain(dateRangeToTimeRangeArray(dateRange))
    .ticks(ticksCount);
};
